import { Injectable } from '@angular/core';
import { AlarmService } from 'src/app/project/shared/services/camera-alarm.service';

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  // AlarmService owns auth-event handling; this injection keeps the root service initialized.
  constructor(
    private alarmService: AlarmService
  ) {
  }
}
